/**
 * QuantitySelect — unified 1–N quantity dropdown.
 *
 * Single source of the quantity UI, used by both the cart (CartSidebar) and the
 * delivery/attendees page so the control looks and behaves identically in both
 * places. Controlled component: pass `value` and an `onChange(nextQty)` that
 * receives the parsed integer.
 *
 * Styling comes from the shared `.lc_qty_select` class (matches the delivery
 * page dropdown); pass extra classes via `className` for context-specific needs.
 */
import React from 'react';

const QuantitySelect = ({ value, onChange, className = '', max = 10, ...rest }) => (
  <select
    className={`lc_qty_select${className ? ' ' + className : ''}`}
    value={value}
    onChange={(e) => onChange(parseInt(e.target.value, 10))}
    {...rest}
  >
    {Array.from({ length: max }, (_, i) => i + 1).map((n) => (
      <option key={n} value={n}>{n}</option>
    ))}
  </select>
);

export default QuantitySelect;
